module.exports = __webpack_public_path__ + "static/media/Backward.32714f18.svg";